// 不需要传要传brand的接口，将接口地址放入下面数组
import {
  ENABLE_GROWTH_RULE,
  GET_SYSTEM_TIME,
  // 渠道不加品牌
  CHANNEL_SITE_LIST,
  CHANNEL_SITE_UPDATE,
  CHANNEL_SITE_SAVE,
  CHANNEL_SITE_DELETE,
  // 平台的请求均不需要加brand 即 cmms/开头的哪些请求
  DICT_SELECT_LIST,
  GET_AREA_LIST,
  // systemSetup.js 全部
  AUTH_NEW_MENU_LIST_BY_USER,
  ACTIVITY_TEAM_ADD_NEW,
  ACTIVITY_TEAM_NEW_LIST,
  ACTIVITY_TEAM_ENABLE,
  ACTIVITY_TEAM_FORBIDDEN,
  ACTIVITY_TEAM_USER_LIST,
  ACTIVITY_TEAM_USER_DELETE,
  GET_DIC_LIST,
  SEARCH_DIC_LIST,
  GET_DIC_VAL_LIST,
  ADD_DIC,
  UPDATE_DIC,
  OP_KEY,
  UPDATE_DIC_VAL,
  ADD_DIC_VAL,
  LIST_OF_ACCOUNT,
  // 管理员管理
  GET_USER_LIST,
  GET_TEAM_LIST,
  SELECT_NEW_MENU_LIST,
  GET_OPTIONAL_APP,
  ADD_NEW_USER,
  GET_USER_INFO,
  ENABLE_USER,
  AUTH_FORBIDDEN_USER,
  // 主体管理
  GET_ORG_LIST,
  ORG_WXMP_LIST,
  CMMS_ORG_ADD,
  ORG_SAVE_ORG_WXMP,
  // menu.js 全部
  MENU_AUTH_MEMULIST,
  MENU_AUTH_MENULIST,
  // login.js 全部
  LOGIN_IS_LOGIN,
  LOGIN_LOGINING,
  LOGIN_LOGOUT,
  // 短链管理
  GET_SHORT_LINK_LIST,
  // 短信管理
  SMS_ACTIVITY_EVENTS,
  SMS_DELETE_BY_ID,
  GET_EVENT_DETAIL,
  SMS_GET_ORG_MSG,
  SMS_TEST_SMS,
  SMS_CONFIG,
  SMS_FIRST_MOBILE,
  SMS_STOP_SEND_TASK_INFO,
  // 获取brand列表
  AUTH_GET_BRAND,
  // CHANNEL_SITE_DELETE,
  // 数据域
  AUTHORITY_LIST_ALL,
  AUTHORITY_LIST_BY_TEAM,
  // 潜客管理
  POSTENTIAL_LIST_NEW,
  SUPPORT_GET_SOURCE,
  // 潜客信息详情
  POTEN_INFO_OLD,
  // 会员详情相关
  USER_TAGS,
  // 会员等级 - 特产情况 - 手动加
  // MEMBER_GET_LEVEL_LIST_FOR_BRAND,
  // 投放效果报表
  PROMOTE_BOARD_OVERVIEW,
  FUNNEL_GET_EVENT_TREE,
  FUNNEL_GET_STEPS,
  PROMOTE_FUNNEL_SETTING_SAVE,
  PROMOTE_FUNNEL_SETTING_LIST,
  PROMOTE_BOARD_FUNNEL_CONVER_SION_RATE,
  PROMOTE_BOARD_FUNNEL_TENDENCY,
  PROMOTE_BOARD_ALL_OVER_VIEW,
  PROMOTE_BOARD_ALL_OVERVIEW_CHART,
  PROMOTE_TASK_PAGE,
  PROMOTE_PRECISION_GET_PREDICT_LABEL_COUNT,
  // 受众
  LABEL_BOARD_LEVEL_DISTRIBUTED,
  SUPPORT_GET_BRAND,
  // 大类小类
  GET_PRODUCT_TYPE,
  GET_PRODUCT_SUB_TYPE,
  // 线下门店
  OFFLINE_STORE_LIST,
  // 权限管理
  AUTH_GET_USER_LIST,
  AUTH_TEAM_NEW_LIST,
  AUTH_MENUS_ADD,
  AUTH_MENUS_EDIT,
  AUTH_NEW_ROLE_TEAM_USER_LIST,
  AUTH_NEW_ROLE_ADD_ACCOUNT_BATCH,
  AUTH_ADD_EFFECTIVE_TIME,
  AUTH_USER_EDIT_NEW,
  // 营销引擎
  WCP_MSG_GET_MATERIAL_LIST,
  MSG_GET_TEMPLATE_LIST,
  // 标签
  LABEL_SELECT_LABEL_TYPE_LIST,
  // 敏感词管理
  SENSITIVE_GET_SENSITIVE_WORDS,
  SENSITIVE_ADD,
  SENSITIVE_EDIT,
  SENSITIVE_DELETE_BY_ID,
  SENSITIVE_BATCH_DELETE_BY_IDS,
  // 大数据人群
  LABEL_SELECT_ODS_GROUP_LIST,
  LABEL_SYNE_ODS_GROUP,
  // 公告
  NOTICE_SELECT_NOTICE_LIST,
  NOTICE_INSET_OR_UPDATE_NOTICE,
  NOTICE_CHANGE_NOTICE_ENABLED,
} from './url';

let whiteConfig = [
  ENABLE_GROWTH_RULE,
  GET_SYSTEM_TIME,
  // 渠道不加品牌
  CHANNEL_SITE_LIST,
  CHANNEL_SITE_UPDATE,
  CHANNEL_SITE_SAVE,
  CHANNEL_SITE_DELETE,
  // 平台的请求均不需要加brand 即 cmms/开头的哪些请求
  DICT_SELECT_LIST,
  GET_AREA_LIST,
  // systemSetup.js 全部
  AUTH_NEW_MENU_LIST_BY_USER,
  ACTIVITY_TEAM_ADD_NEW,
  ACTIVITY_TEAM_NEW_LIST,
  ACTIVITY_TEAM_ENABLE,
  ACTIVITY_TEAM_FORBIDDEN,
  ACTIVITY_TEAM_USER_LIST,
  ACTIVITY_TEAM_USER_DELETE,
  GET_DIC_LIST,
  SEARCH_DIC_LIST,
  GET_DIC_VAL_LIST,
  ADD_DIC,
  UPDATE_DIC,
  OP_KEY,
  UPDATE_DIC_VAL,
  ADD_DIC_VAL,
  LIST_OF_ACCOUNT,
  // 管理员管理
  GET_USER_LIST,
  GET_TEAM_LIST,
  SELECT_NEW_MENU_LIST,
  GET_OPTIONAL_APP,
  ADD_NEW_USER,
  GET_USER_INFO,
  ENABLE_USER,
  AUTH_FORBIDDEN_USER,
  // 主体管理
  GET_ORG_LIST,
  ORG_WXMP_LIST,
  CMMS_ORG_ADD,
  ORG_SAVE_ORG_WXMP,
  // menu.js 全部
  MENU_AUTH_MEMULIST,
  MENU_AUTH_MENULIST,
  // login.js 全部
  LOGIN_IS_LOGIN,
  LOGIN_LOGINING,
  LOGIN_LOGOUT,
  // 短链管理
  GET_SHORT_LINK_LIST,
  // 短信管理
  SMS_ACTIVITY_EVENTS,
  SMS_DELETE_BY_ID,
  GET_EVENT_DETAIL,
  SMS_GET_ORG_MSG,
  SMS_TEST_SMS,
  SMS_CONFIG,
  SMS_FIRST_MOBILE,
  SMS_STOP_SEND_TASK_INFO,
  // 获取brand列表
  AUTH_GET_BRAND,
  // CHANNEL_SITE_DELETE,
  // 数据域
  AUTHORITY_LIST_ALL,
  AUTHORITY_LIST_BY_TEAM,
  // 潜客管理
  POSTENTIAL_LIST_NEW,
  SUPPORT_GET_SOURCE,
  // 潜客信息详情
  POTEN_INFO_OLD,
  // 会员详情相关
  USER_TAGS,
  // 会员等级 - 特产情况 - 手动加
  // MEMBER_GET_LEVEL_LIST_FOR_BRAND,
  // 投放效果报表
  PROMOTE_BOARD_OVERVIEW,
  FUNNEL_GET_EVENT_TREE,
  FUNNEL_GET_STEPS,
  PROMOTE_FUNNEL_SETTING_SAVE,
  PROMOTE_FUNNEL_SETTING_LIST,
  PROMOTE_BOARD_FUNNEL_CONVER_SION_RATE,
  PROMOTE_BOARD_FUNNEL_TENDENCY,
  PROMOTE_BOARD_ALL_OVER_VIEW,
  PROMOTE_BOARD_ALL_OVERVIEW_CHART,
  PROMOTE_TASK_PAGE,
  PROMOTE_PRECISION_GET_PREDICT_LABEL_COUNT,
  // 受众
  LABEL_BOARD_LEVEL_DISTRIBUTED,
  SUPPORT_GET_BRAND,
  // 大类小类
  GET_PRODUCT_TYPE,
  GET_PRODUCT_SUB_TYPE,
  // 线下门店
  OFFLINE_STORE_LIST,
  // 权限管理
  AUTH_GET_USER_LIST,
  AUTH_TEAM_NEW_LIST,
  AUTH_MENUS_ADD,
  AUTH_MENUS_EDIT,
  AUTH_NEW_ROLE_TEAM_USER_LIST,
  AUTH_NEW_ROLE_ADD_ACCOUNT_BATCH,
  AUTH_ADD_EFFECTIVE_TIME,
  AUTH_USER_EDIT_NEW,
  // 营销引擎
  WCP_MSG_GET_MATERIAL_LIST,
  MSG_GET_TEMPLATE_LIST,
  // 标签
  LABEL_SELECT_LABEL_TYPE_LIST,
  // 敏感词管理
  SENSITIVE_GET_SENSITIVE_WORDS,
  SENSITIVE_ADD,
  SENSITIVE_EDIT,
  SENSITIVE_DELETE_BY_ID,
  SENSITIVE_BATCH_DELETE_BY_IDS,
  // 大数据人群
  LABEL_SELECT_ODS_GROUP_LIST,
  LABEL_SYNE_ODS_GROUP,
  // 公告
  NOTICE_SELECT_NOTICE_LIST,
  NOTICE_INSET_OR_UPDATE_NOTICE,
  NOTICE_CHANGE_NOTICE_ENABLED,
];
export default whiteConfig;
